import cssVariables from '@/assets/cssVariables.json';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const primevueLcpTheme = definePreset(Aura, {
    semantic: {
        primary: {
            50: cssVariables.selectionProgressionBlue['50'],
            100: cssVariables.selectionProgressionBlue['100'],
            200: cssVariables.selectionProgressionBlue['200'],
            300: cssVariables.selectionProgressionBlue['300'],
            400: cssVariables.selectionProgressionBlue['400'],
            500: cssVariables.selectionProgressionBlue['500'],
            600: cssVariables.selectionProgressionBlue['600'],
            700: cssVariables.selectionProgressionBlue['700'],
            800: cssVariables.selectionProgressionBlue['800'],
            900: cssVariables.selectionProgressionBlue['900'],
            950: cssVariables.selectionProgressionBlue['950'],
        },
    },
});
